import { mount } from '../dom-lifecycle';

// Blokuje przyciski submit po pierwszym poprawnym wysłaniu formularza
// wysyłanego klasycznym POST-em (np. logowanie), żeby zapobiec podwójnemu
// kliknięciu i pokazać spinner do czasu odpowiedzi serwera (przeładowania strony).
// Walidacja (.needs-validation) zatrzymuje propagację przy błędnym formularzu
// (stopImmediatePropagation) — ten handler, importowany później, uruchamia się
// więc tylko gdy formularz przeszedł walidację.
mount('.js-lock-on-submit', form => {
	let submitting = false;
	const submitButtons = () => $(form.elements).filter('[type=submit]');
	const reset = () => {
		submitting = false;
		submitButtons().prop('disabled', false);
	};

	$(form).on('submit', function (event) {
		// Blokuj ponowne wysłanie (kolejne kliknięcie, Enter, submit programowy)
		// dopóki trwa pierwsze; disabled na przycisku łapie kliknięcia,
		// a ten guard łapie pozostałe ścieżki.
		if (submitting) {
			event.preventDefault();
			event.stopImmediatePropagation();
			return;
		}
		submitting = true;
		submitButtons().prop('disabled', true);
	}).on('submit-invalid', reset);

	// Przywróć przyciski po powrocie ze strony z cache przeglądarki (bfcache),
	// gdzie formularz zachowałby stan disabled.
	$(window).on('pageshow', event => {
		if (event.originalEvent?.persisted) {
			reset();
		}
	});
});
